const getClientSlugFromDomain = () => {
  const { host } = window.location;

  if (!host) return '';

  if (process.env.VUE_APP_MOCK && process.env.VUE_APP_MOCK_CLIENT) {
    return process.env.VUE_APP_MOCK_CLIENT;
  }

  return host
    .split('.')
    .filter(item => Boolean(item) && item !== 'www')[0];
};

const getProductFromDomain = () => {
  const { pathname } = window.location;

  return pathname
    .split('/')
    .filter(item => Boolean(item))[0];
};

const getTokenFromURL = () => {
  if (process.env.VUE_APP_MOCK && process.env.VUE_APP_MOCK_TOKEN) {
    return process.env.VUE_APP_MOCK_TOKEN;
  }

  const currentURL = new URL(window.location);

  return currentURL.searchParams.get('token');
};

const getIsAthleteShield = () => {
  const client = getClientSlugFromDomain();
  const token = getTokenFromURL();

  return client === 'athleteshield' && token === process.env.VUE_APP_ATHLETESHIELD_TOKEN;
};

export default {
  getProductFromDomain,
  getClientSlugFromDomain,
  getTokenFromURL,
  getIsAthleteShield,
};
